import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Coin economy")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mb-0"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder-glow"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "placeholder col-12",
  style: {"height":"300px"}
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "row"
}
const _hoisted_9 = { class: "col-md-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted" }, "Net balance", -1)
const _hoisted_11 = { class: "fs-2 fw-bold" }
const _hoisted_12 = { class: "fs-7 text-muted" }
const _hoisted_13 = { class: "col-md-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
        : (_ctx.loading && !_ctx.loaded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, _toDisplayString(Math.round(_ctx.economy.netBalance ?? 0).toLocaleString("en-US")), 1),
                _createElementVNode("div", _hoisted_12, " Out: " + _toDisplayString(Math.round(_ctx.economy.coinsOut ?? 0).toLocaleString("en-US")), 1),
                _createVNode(_component_apexchart, {
                  type: "donut",
                  height: "260",
                  options: _ctx.donutOptions,
                  series: _ctx.donutSeries
                }, null, 8, ["options", "series"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_apexchart, {
                  type: "area",
                  height: "300",
                  options: _ctx.lineOptions,
                  series: _ctx.lineSeries
                }, null, 8, ["options", "series"])
              ])
            ]))
    ])
  ]))
}